import React from "react";
import HomeMember from "./HomeMember";
import { groupBy } from "lodash";

function HomeApplicants({ application }) {
  let applicants = [];
  application.HomeData?.forEach((hd) => {
    if (!hd.members || !Array.isArray(hd.members)) {
      console.log("NO HD MEMBERS", application);
    }
    hd.members.forEach((m) =>
      applicants.push({
        contactid: m.contactid,
        type: m.type,
        firstname: m.firstname,
        middlename: m.middlename,
        lastname: m.lastname,
        fullname: m.fullname,
        name: `${m.firstname} ${
          m.middlename !== null ? `${m.middlename} ` : ""
        }${m.lastname}`,
        firstlast: `${m.firstname} ${m.lastname}`,
        primarycontact: m.primarycontact,
        createdon: m.createdon,
        updatedon: m.updatedon,
        effective: m.effective,
        expiration: m.expiration,
        emailaddress1: m.emailaddress1,
        emailaddress2: m.emailaddress2,
        telephone1: m.telephone1,
        telephone2: m.telephone2,
        mobilephone: m.mobilephone,
        source: hd.source,
      })
    );
  });

  const groupedMembers = Object.values(groupBy(applicants, "firstlast"));

  return (
    <>
      {groupedMembers.map((m, index) => (
        <HomeMember member={m} key={`hm-${index}`} />
      ))}
    </>
  );
}

export default HomeApplicants;
